<template>
    <div class="ButtonContainer">
        <h5>Primary</h5>
        <div class="ButtonContainer__row">
            <RPButton size="xl" />
            <RPButton
                size="xl"
                disabled
            />
            <RPButton size="lg" />
            <RPButton size="md" />
            <RPButton size="sm" />
        </div>
        <h5>Secondary</h5>
        <div class="ButtonContainer__row">
            <RPButton
                type="secondary"
                size="xl"
            />
            <RPButton
                type="secondary"
                size="xl"
                disabled
            />
            <RPButton
                type="secondary"
                size="lg"
            />
            <RPButton
                type="secondary"
                size="md"
            />
            <RPButton
                type="secondary"
                size="sm"
            />
        </div>
        <h5>Tertiary</h5>
        <div class="ButtonContainer__row">
            <RPButton
                type="tertiary"
                size="xl"
            />
            <RPButton
                type="tertiary"
                size="xl"
                disabled
            />
            <RPButton
                type="tertiary"
                size="lg"
            />
            <RPButton
                type="tertiary"
                size="md"
            />
            <RPButton
                type="tertiary"
                size="sm"
            />
        </div>
        <h5>Icon Variant</h5>
        <div class="ButtonContainer__row">
            <RPButton
                size="xl"
                :icon="HomeIcon"
            />
            <RPButton
                size="xl"
                type="tertiary"
                :icon="HomeIcon"
            />
            <RPButton
                size="xl"
                :icon="HomeIcon"
                disabled
            />
            <RPButton
                size="lg"
                :icon="HomeIcon"
            />
            <RPButton
                size="md"
                :icon="HomeIcon"
            />
            <RPButton
                size="sm"
                :icon="HomeIcon"
            />
        </div>
        <h5>Saving</h5>
        <div class="ButtonContainer__row">
            <RPButton
                size="xl"
                :status="status.SAVING"
            />
            <RPButton
                size="lg"
                :status="status.SAVING"
            />
            <RPButton
                size="md"
                :status="status.SAVING"
            />
            <RPButton
                size="sm"
                :status="status.SAVING"
            />
        </div>
        <h5>Split Button</h5>
        <div class="ButtonContainer__row">
            <RPSplitButton :options="opt">
                Submit
            </RPSplitButton>
            <RPSplitButton
                :options="opt"
                disabled
            >
                Submit
            </RPSplitButton>
        </div>
        <h5>Nav Tabs</h5>
        <div class="ButtonContainer__row">
            <RPNavTab>Nav Tab</RPNavTab>
            <RPNavTab :is-active="true">
                Nav Tab
            </RPNavTab>
            <RPNavTab disabled>
                Nav Tab
            </RPNavTab>
            <RPSubTab>Sub Tab</RPSubTab>
            <RPSubTab :is-active="false">
                Sub Tab
            </RPSubTab>
            <RPSubTab disabled>
                Sub Tab
            </RPSubTab>
        </div>
        <h5>Dropdown Buttons</h5>
        <h5>Primary</h5>
        <div class="ButtonContainer__row">
            <RPDropdownButton
                v-model="select1"
                :options="opt"
                default-label="Label"
                :show-selection="false"
            />
            <RPDropdownButton
                v-model="select1"
                :options="opt"
                default-label="Label"
                :default-icon="HomeIcon"
                :show-selection="false"
            />
            <RPDropdownButton
                v-model="select2"
                :options="opt"
                :default-icon="HomeIcon"
                default-label="Label"
                required
            />
            <RPDropdownButton
                v-model="select3"
                :options="opt"
                :default-icon="HomeIcon"
                default-label="Label"
                disabled
            />
        </div>
        <h5>Secondary</h5>
        <div class="ButtonContainer__row">
            <RPDropdownButton
                v-model="select1"
                :options="opt"
                default-label="Label"
                :show-selection="false"
                type="secondary"
            />
            <RPDropdownButton
                v-model="select1"
                :options="opt"
                default-label="Label"
                :default-icon="HomeIcon"
                :show-selection="false"
                type="secondary"
            />
            <RPDropdownButton
                v-model="select1"
                :options="opt"
                default-label="Label"
                :default-icon="HomeIcon"
                type="secondary"
            />
            <RPDropdownButton
                v-model="select1"
                :options="opt"
                default-label="Label"
                :default-icon="HomeIcon"
                type="secondary"
                disabled
            />
        </div>
        <h5>Tertiary</h5>
        <div class="ButtonContainer__row">
            <RPDropdownButton
                v-model="select1"
                :options="opt"
                default-label="Label"
                :show-selection="false"
                type="tertiary"
            />
            <RPDropdownButton
                v-model="select1"
                :options="opt"
                default-label="Label"
                :default-icon="HomeIcon"
                :show-selection="false"
                type="tertiary"
            />
            <RPDropdownButton
                v-model="select1"
                :options="opt"
                default-label="Label"
                :default-icon="HomeIcon"
                type="tertiary"
            />
            <RPDropdownButton
                v-model="select1"
                :options="opt"
                default-label="Label"
                :default-icon="HomeIcon"
                type="tertiary"
                disabled
            />
        </div>
        <h5>Pagination</h5>
        <div class="ButtonContainer__column">
            <Pagination
                :items="items"
                :pagination="pagination"
                :show-total="true"
            />
            <Pagination
                :items="items"
                :pagination="pagination"
                status="loading"
                show-total
            />
            <Pagination
                :items="items"
                :pagination="pagination"
                status="loading"
            />
            <Pagination
                :items="items"
                :pagination="pagination"
                :show-total="false"
            />
            <Pagination
                :items="items"
                :pagination="pagination1"
                :show-total="false"
            />
            <Pagination
                :items="items"
                :pagination="pagination2"
                :show-total="false"
            />
        </div>
    </div>
</template>

<script>
import RPButton from 'components/Basic/Buttons/RPButton.vue';
import RPSplitButton from 'components/Basic/Buttons/RPSplitButton.vue';
import RPNavTab from 'components/Basic/Buttons/RPNavTab.vue';
import RPSubTab from 'components/Basic/Buttons/RPSubTab.vue';
import RPDropdownButton from 'components/Basic/Buttons/DropdownButton/RPDropdownButton.vue';
import {House1} from "@reviewpush/streamline-regular/lib/interface-essential/Home";
import Pagination from 'components/Complex/Pagination/Pagination.vue';
import status from 'status';

export default {
    components: {
        RPButton,
        RPSplitButton,
        RPNavTab,
        RPSubTab,
        RPDropdownButton,
        Pagination
    },

    data() {
        return {
            status,

            select1: '',
            select2: '',
            select3: '',
            select4: '',

            opt: [
                {
                    label: 'Option 1',
                    value: 'opt1',
                    icon: House1,
                },
                {
                    label: 'Option 2',
                    value: 'opt2',
                },
                {
                    label: 'Option 3',
                    value: 'opt3',
                },
            ],
            opt2: [
                {
                    label: 'Option 1',
                    value: 'opt1',
                    icon: 'placeholder'
                },
                {
                    label: 'Option 2',
                    value: 'opt2',
                    icon: 'placeholder'
                },
                {
                    label: 'Option 3',
                    value: 'opt3',
                    icon: 'placeholder'
                },
            ],

            pagination: {
                currentPage: 5,
                totalPages: 10,
            },
            pagination1: {
                currentPage: 1,
                totalPages: 10,
            },
            pagination2: {
                currentPage: 10,
                totalPages: 10,
            },
            items: {
                start: -1,
                end: -10,
                total: -100,
                count: -1,
                name: 'Items',
            },
        };
    },
    computed: {
        HomeIcon(){
            return House1;
        },
    },
};
</script>

<style lang="scss">
    .ButtonContainer {
        margin: 50px;
        padding-bottom: 500px;

        h5 {
            margin-bottom: 1rem;
        }

        &__row {
            display: flex;
            & > * {
                margin: 0 25px 25px 0;
            }
        }
        &__column {
            display: flex;
            flex-direction: column;
            & > * {
                margin: 0 25px 25px 0;
            }
        }
    }
</style>
